var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "wrapper__element", staticClass: "concierce_wrapper" },
    [
      _c(
        "div",
        { staticClass: "contents" },
        [
          _c("div", { staticClass: "voucher_post_box" }, [
            _c("div", { staticClass: "voucher_post" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "voucher_post-info medium" }, [
                _c("div", { staticClass: "voucher_post-text" }, [
                  _c("div", { staticClass: "voucher_post-amount" }, [
                    _c("span", [_vm._v(_vm._s(_vm.totalCouponSum))]),
                    _vm._v(" 매\n            ")
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("infotagUse", { attrs: { expDate: _vm.endDate } }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isProud,
                  expression: "isProud"
                }
              ],
              staticClass: "voucher_greet"
            },
            [
              _c("p", { staticClass: "greet_sub" }, [
                _vm._v("“I’M PROUD OF YOU”")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "greet_txt" }, [
                _vm._v("당신이 자랑스럽습니다.")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "greet_sender" }, [
                _c("span", { staticClass: "sender" }, [
                  _vm._v(_vm._s(_vm.aboName))
                ]),
                _vm._v("님이 보내신 선물입니다.\n      ")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isNext,
                  expression: "!isNext"
                }
              ],
              staticClass: "voucher_coupon_agree_box"
            },
            [
              _c("div", { staticClass: "voucher_coupon_agree" }, [
                _c("div", { staticClass: "coupon_agree_all" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.allChecked,
                        expression: "allChecked"
                      }
                    ],
                    ref: "agree__element",
                    staticClass: "form_agree",
                    attrs: { type: "checkbox", id: "form_agree_all_coupon" },
                    domProps: {
                      checked: Array.isArray(_vm.allChecked)
                        ? _vm._i(_vm.allChecked, null) > -1
                        : _vm.allChecked
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.allChecked,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.allChecked = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.allChecked = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.allChecked = $$c
                          }
                        },
                        function($event) {
                          return _vm.checkedAll($event)
                        }
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "form_agree_all_coupon" } }, [
                    _vm._v("파이토 카페 음료 바우처 이용약관 동의")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "coupon_agree_detail" }, [
                  _c("div", { staticClass: "coupon_agree_detail_inner" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.checkList[0],
                          expression: "checkList[0]"
                        }
                      ],
                      staticClass: "form_agree",
                      attrs: { type: "checkbox", id: "form_agree_1" },
                      domProps: {
                        checked: Array.isArray(_vm.checkList[0])
                          ? _vm._i(_vm.checkList[0], null) > -1
                          : _vm.checkList[0]
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.checkList[0],
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(_vm.checkList, 0, $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.checkList,
                                    0,
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.checkList, 0, $$c)
                            }
                          },
                          function($event) {
                            return _vm.check($event)
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "form_agree_1" } }, [
                      _vm._v("[필수] 파이토 카페 음료 바우처 이용동의")
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "agree_detail_pop",
                        attrs: { "data-layer": "voucher-agree-layer" },
                        on: {
                          click: function($event) {
                            return _vm.termsPopup(true, "voucher")
                          }
                        }
                      },
                      [_vm._v("자세히 보기")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "coupon_agree_detail_inner" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.checkList[1],
                          expression: "checkList[1]"
                        }
                      ],
                      staticClass: "form_agree",
                      attrs: { type: "checkbox", id: "form_agree_2" },
                      domProps: {
                        checked: Array.isArray(_vm.checkList[1])
                          ? _vm._i(_vm.checkList[1], null) > -1
                          : _vm.checkList[1]
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.checkList[1],
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(_vm.checkList, 1, $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.checkList,
                                    1,
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.checkList, 1, $$c)
                            }
                          },
                          function($event) {
                            return _vm.check($event)
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "form_agree_2" } }, [
                      _vm._v("[필수] 개인정보 수집 및 이용동의")
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "agree_detail_pop",
                        attrs: { "data-layer": "personal-agree-layer" },
                        on: {
                          click: function($event) {
                            return _vm.termsPopup(true, "personal")
                          }
                        }
                      },
                      [_vm._v("자세히 보기")]
                    )
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("counter", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.exchange,
                expression: "exchange"
              }
            ],
            ref: "counter__component",
            attrs: { text: "사용", totalCouponSum: _vm.totalCouponSum }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.exchange,
                  expression: "exchange"
                }
              ],
              staticClass: "voucher_contact"
            },
            [
              _c("p", [
                _vm._v("매장 선택 후, 직원 확인용 비밀번호를 입력해주세요.")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "contact_tel" }, [
                _c("div", { staticClass: "contact_tel_1" }, [
                  _c(
                    "select",
                    {
                      staticClass: "form-tel",
                      attrs: { title: "ABC 지역 입력" },
                      on: {
                        change: function($event) {
                          return _vm.selectBoxChange($event)
                        }
                      }
                    },
                    _vm._l(_vm.storeInfo, function(storeInfo, i) {
                      return _c(
                        "option",
                        { key: i, domProps: { value: storeInfo.store_code } },
                        [_vm._v(_vm._s(storeInfo.store_name) + " ABC")]
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "contact_tel_2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.pinNum,
                        expression: "pinNum"
                      }
                    ],
                    ref: "pw__element",
                    staticClass: "form-tel",
                    attrs: {
                      type: "password",
                      placeholder: "****",
                      title: "비밀번호 입력"
                    },
                    domProps: { value: _vm.pinNum },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.pinNum = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "concierce_btn_area" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.exchange,
                    expression: "exchange"
                  }
                ],
                staticClass: "btn-pop-submit",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.exchangeCoupon()
                  }
                }
              },
              [_vm._v("바우처 교환 완료 처리")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.exchangeSuccess,
                    expression: "exchangeSuccess"
                  }
                ],
                staticClass: "btn-pop-submit",
                attrs: { type: "button", disabled: _vm.exchangeSuccess }
              },
              [_vm._v("교환 완료")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expired,
                    expression: "expired"
                  }
                ],
                staticClass: "btn-pop-submit",
                staticStyle: { display: "none" },
                attrs: { type: "button", disabled: "" }
              },
              [_vm._v("사용 기한 만료")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "concierce_btn_area" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isNext,
                    expression: "!isNext"
                  }
                ],
                staticClass: "btn-pop-submit",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.next()
                  }
                }
              },
              [_vm._v("이용동의 및 직원확인")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isCancel,
                    expression: "isCancel"
                  }
                ],
                staticClass: "btn-pop-submit",
                attrs: { type: "button", disabled: "" }
              },
              [_vm._v("회수된 바우처")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expired,
                    expression: "expired"
                  }
                ],
                staticClass: "btn-pop-submit",
                staticStyle: { display: "none" },
                attrs: { type: "button", disabled: "" }
              },
              [_vm._v("사용 기한 만료")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.exchangeSuccess,
                    expression: "exchangeSuccess"
                  }
                ],
                staticClass: "btn-pop-submit",
                attrs: { type: "button", disabled: _vm.exchangeSuccess }
              },
              [_vm._v("교환 완료")]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "layer-area layer_section type-narrow-b",
          class: { showing: _vm.popupFlag1 },
          attrs: { id: "voucher-agree-layer" }
        },
        [
          _c("div", { staticClass: "layer_section-container" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "align-box size-auto" }, [
              _c(
                "button",
                {
                  staticClass: "btn-modal_close",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.termsPopup(false, "voucher")
                    }
                  }
                },
                [_vm._v("확인")]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "layer-area layer_section type-narrow-b",
          class: { showing: _vm.popupFlag2 },
          attrs: { id: "personal-agree-layer" }
        },
        [
          _c("div", { staticClass: "layer_section-container" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "align-box size-auto" }, [
              _c(
                "button",
                {
                  staticClass: "btn-modal_close",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.termsPopup(false, "personal")
                    }
                  }
                },
                [_vm._v("확인")]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "voucher_post-img" }, [
      _c("img", {
        attrs: {
          src: require("./images/concierce_voucher_mo.png"),
          alt: "DIAMOND CONCIERGE PHYTO CAFE 음료 바우처"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layer-content" }, [
      _c("div", { staticClass: "agree-area" }, [
        _c("div", { staticClass: "agree-title-area" }, [
          _c("h1", { staticClass: "agree-title" }, [
            _vm._v("파이토 카페 음료 바우처 이용동의")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "agree-content" }, [
          _c("ol", [
            _c("li", [
              _vm._v(
                "파이토 카페 음료 바우처는 한국암웨이 다이아몬드 이상 리더에게 제공되는 다이아몬드 컨시어지 혜택입니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "다이아몬드 컨시어지 혜택자에게 선물받은 바우처는 판매가 불가능하며, 소비자로서 최종 소비만 가능합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("이용기한내에 바우처를 사용하시길 권장드립니다.")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("바우처 이용기한내 미사용 시, 분실 시 재발급 불가합니다.")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("바우처가 포함된 메시지 삭제 시 재발송 불가합니다.")
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layer-content" }, [
      _c("div", { staticClass: "agree-area" }, [
        _c("div", { staticClass: "agree-title-area" }, [
          _c("h1", { staticClass: "agree-title" }, [
            _vm._v("개인정보 수집 및 이용동의")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "agree-content" }, [
          _c("p", [
            _vm._v(
              "한국암웨이㈜는 다이아몬드 컨시어지 파이토 카페 음료 바우처 제공을 위하여 다음과 같이 귀하의 개인정보를 수집 및 이용합니다."
            )
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "agree-list" }, [
            _c("li", [
              _vm._v(
                "\n                수집하는 개인정보 항목\n                "
              ),
              _c("span", [_vm._v("성명, 전화번호")])
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n                개인정보의 수집 및 이용목적\n                "
              ),
              _c("span", [_vm._v("파이토 카페 음료 바우처 발행")])
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n                개인정보의 보유 및 이용기간\n                "
              ),
              _c("span", [_vm._v("동의일로부터 6개월")])
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "※ 귀하는 위 동의를 거부할 권리가 있으나, 이에 동의하지 않는 경우 다이아몬드 컨시어지 파이토 카페 음료 바우처 혜택은 제공되지 않습니다."
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c38d6928", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c38d6928","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/concierge/giftCoupon.vue
// module id = null
// module chunks = 